import ReactGA from 'react-ga4';

const MEASUREMENT_ID_PRODUCTION = 'G-7B4SD4VM8H'
const MEASUREMENT_ID_STAGING = 'G-CEKHXYCJY1'

interface IUser {
  user_id: number,
  user_type?: string,
}

export enum gaEventCategories {
  orders = "orders",
  users = "users",
  discounts = "discounts",
  fixed_trips = "fixed_trips",
  taxibon = "taxibon"
}

export enum gaEvenActions {
  ordered_trip = "ordered_trip",
  cancelled_trip = "cancelled_trip",
  logged_in = "logged_in",
  logged_out = "logged_out",
  created_discount_campaign = "created_discount_campaign",
  removed_discount_campaign = "removed_discount_campaign",
  created_fixed_trip = "created_fixed_trip",
  removed_fixed_trip = "removed_fixed_trip",
  created_taxibon = "created_taxibon",
  removed_taxibon = "removed_taxibon"
}

function initGA() {
  if (typeof window !== "undefined") {
    if (window.location.origin === "https://book.dantaxi.dk") {
      // PRODUCTION
      ReactGA.initialize(MEASUREMENT_ID_PRODUCTION)
    } else {
      // STAGING
      ReactGA.initialize(MEASUREMENT_ID_STAGING)
      ReactGA.gtag('config', MEASUREMENT_ID_STAGING, {
        'debug_mode': true, // Data filter developer mode
        'traffic_type': 'dev' // Data filter internal mode
      })
    }
  }
}

function gaEvent(eventCategory: gaEventCategories, eventAction: gaEvenActions, user?: IUser, params?: object) {
  ReactGA.gtag('set', 'user_properties', user);
  ReactGA.gtag('event', eventAction, {
    'event_category': eventCategory,
    ...params
  })
}

function gaLogin(user: IUser, logInEvent: boolean = true) {
  ReactGA.gtag('set', 'user_properties', {
    user_id: null,
    user_type: null
  }); // Clears possible previously logged in user properties before setting the updated ones
  ReactGA.gtag('set', 'user_properties', user);
  if (logInEvent) gaEvent(gaEventCategories.users, gaEvenActions.logged_in, user, {})
}

function gaLogout() {
  gaEvent(gaEventCategories.users, gaEvenActions.logged_out)
  ReactGA.gtag('set', 'user_properties', {
    user_id: null,
    user_type: null
  });
}

export { initGA, gaEvent, gaLogin, gaLogout };
